import { IconType } from '@/types';

export default function PickupIcon({ className, width = 24, height = 24 }: IconType) {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 19'
      fill='none'
    >
      <path
        d='M7.5 12.875L9.75 13.625C9.75 13.625 15.375 12.5 16.125 12.5C16.875 12.5 16.875 13.25 16.125 14C15.375 14.75 12.75 17 10.5 17C8.25 17 6.75 15.875 5.25 15.875H1.5'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M1.5 11.375C2.25 10.625 3.75 9.5 5.25 9.5C6.75 9.5 10.3125 11 10.875 11.75C11.4375 12.5 9.75 13.625 9.75 13.625M6 7.25V4.25C6 4.05109 6.07902 3.86032 6.21967 3.71967C6.36032 3.57902 6.55109 3.5 6.75 3.5H15.75C15.9489 3.5 16.1397 3.57902 16.2803 3.71967C16.421 3.86032 16.5 4.05109 16.5 4.25V10.25'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M9.375 3.5H13.125V6.875H9.375V3.5Z'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
